export default __webpack_public_path__ + "static/media/ring-2@3x.3758c64c.jpg";